// extracted by mini-css-extract-plugin
module.exports = {"durationSelect":"index_durationSelect__CKIgK","selected":"index_selected__UDoY3","hot":"index_hot__wiE4Z","gou":"index_gou__cna4U"};